// extracted by mini-css-extract-plugin
export default {"app":"App_app__GuJBs","link":"App_link__hUoGZ"};